<div class="grid-data dashboard-view">
  <!-- Risk Overview -->
  <div class="wrappers-cont risk-overview">
    <div class="wrapper section2">
      <div class="graph-label">Risk Overview</div>
      <div class="risk-cont">
        <div class="graph-cont d-flex align-items-center justify-content-center"
             *ngIf="appSummaryResponse && appSummaryResponse[riskProgressCircleChartKey]?.showMedHigh">
          <app-progress-circle [classref]="'.risk-chart'"
                               [max]="100"
                               [value]="((appSummaryResponse[riskProgressCircleChartKey]['M'] + appSummaryResponse[riskProgressCircleChartKey]['H']) / totalCount) * 100">
            <div class="risk-chart" style="width: 214px; height: 214px;"></div>
          </app-progress-circle>
          <div class="graph-legend progress-circle">
            <!--<div class="big-number">{{(currentConfig?.dashboardViewConfig?.section3?.progressCircle1?.value |-->
            <!--roundpercent: 0}}-->
            <!--</div>-->
            <div class="big-number color-H">
              {{(appSummaryResponse[riskProgressCircleChartKey]['M'] + appSummaryResponse[riskProgressCircleChartKey]['H']) / totalCount | roundpercent:0}}
            </div>
            <div class="desc-text color-H">Med & High Risk
            </div>
          </div>
        </div>
        <div class="graph-cont d-flex align-items-center justify-content-center {{riskRateMapping[appSummaryResponse[riskProgressCircleChartKey]?.singleRating]}}"
             *ngIf="appSummaryResponse && !appSummaryResponse[riskProgressCircleChartKey]?.showMedHigh && appSummaryResponse[riskProgressCircleChartKey]?.singleRating">
          <app-progress-circle [classref]="'.risk-chart-2'"
                               [max]="100"
                               [value]="100" [icon]="appSummaryResponse[riskProgressCircleChartKey]?.singleRating === 'L' ? '&#x2713;': null"
                               [overridecolor]="colorMapping[appSummaryResponse[riskProgressCircleChartKey]?.singleRating]">
            <div class="risk-chart-2" style="width: 214px; height: 214px;"></div>
          </app-progress-circle>
          <div class="graph-legend progress-circle">
            <!--<div class="big-number">{{(currentConfig?.dashboardViewConfig?.section3?.progressCircle1?.value |-->
            <!--roundpercent: 0}}-->
            <!--</div>-->
            <div class="desc-text color-{{appSummaryResponse[riskProgressCircleChartKey]?.singleRating}}">
              {{riskRateMapping[appSummaryResponse[riskProgressCircleChartKey]?.singleRating]}} Risk
            </div>
          </div>
        </div>
        <div class="d-flex flex-column justify-content-center risk-content-ratings"
             [ngClass]="{'invisible' : (appSummaryResponse && !appSummaryResponse[riskProgressCircleChartKey]?.showMedHigh && appSummaryResponse[riskProgressCircleChartKey]?.singleRating) }">
          <div class="d-flex align-items-center">
            <div class="risk-content-label">
              Medium
            </div>
            <div class="progress bg-M" [style.width]="(appSummaryResponse[riskProgressCircleChartKey]?.M / totalCount) | roundpercent: 0">
            </div>
            <div class="risk-content-percent">
              {{(appSummaryResponse[riskProgressCircleChartKey]?.M / totalCount) | roundpercent: 0}}
            </div>
          </div>

          <div class="d-flex align-items-center" *ngIf="appSummaryResponse[riskProgressCircleChartKey]">
            <div class="risk-content-label">
              High
            </div>
            <div class="progress bg-H" [style.width]="(appSummaryResponse[riskProgressCircleChartKey]?.H / totalCount) | roundpercent: 0">
            </div>
            <div class="risk-content-percent">
              {{(appSummaryResponse[riskProgressCircleChartKey]?.H / totalCount) | roundpercent: 0}}
            </div>
          </div>
        </div>
        <div class="d-flex flex-row flex-wrap summary-wrapper justify-content-between align-items-center">
          <ng-container *ngFor="let item of riskSummaryItems">
            <div class="summary-cont-value">
              <div class="big-number {{item?.class}}"
                   *ngIf="(item.value / totalCount) * 100 > 0 && (item.value / totalCount) * 100 < 100">
                {{ item.value / totalCount | roundpercent: 0}}
              </div>
              <div class="big-number {{item?.class}}" *ngIf="(item.value / totalCount) * 100 <= 0">0%</div>
              <div class="big-number {{item?.class}}" *ngIf="(item.value / totalCount) * 100 >= 100">100%</div>
              <div class="label">
                <ng-container *ngIf="item?.showWarningIcon">
                  <i class="fa fa-exclamation-circle color-H"></i>
                </ng-container>
                {{item.label}}
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <!-- Brand Safety Risk -->
  <div class="wrappers-cont brand-safety-risk" *ngIf="currentConfig?.key === 'apps' || currentConfig?.key === 'ctv'">
    <div class="wrapper">
      <div class="graph-label">Brand Safety Risk</div>
      <div class="risk-cont">
        <div class="graph-cont d-flex align-items-center justify-content-center"
             *ngIf="appSummaryResponse && appSummaryResponse?.appDescriptionBrandSafetyRating?.showMedHigh">
          <app-progress-circle [classref]="'.brandsafety-risk-chart'"
                               [max]="100"
                               [value]="((appSummaryResponse?.appDescriptionBrandSafetyRating['M'] +
                               appSummaryResponse?.appDescriptionBrandSafetyRating['H']) / totalCount) * 100">
            <div class="brandsafety-risk-chart" style="width: 214px; height: 214px;"></div>
          </app-progress-circle>
          <div class="graph-legend progress-circle">
            <!--<div class="big-number">{{(currentConfig?.dashboardViewConfig?.section3?.progressCircle1?.value |-->
            <!--roundpercent: 0}}-->
            <!--</div>-->
            <div class="big-number color-H">
              {{(appSummaryResponse?.appDescriptionBrandSafetyRating['M'] +
              appSummaryResponse?.appDescriptionBrandSafetyRating['H']) / totalCount | roundpercent: 0}}
            </div>
            <div class="desc-text color-H">Med & High Risk
            </div>
          </div>
        </div>

        <div class="graph-cont {{riskRateMapping[appSummaryResponse?.appDescriptionBrandSafetyRating?.singleRating]}}"
             *ngIf="appSummaryResponse && !appSummaryResponse?.appDescriptionBrandSafetyRating?.showMedHigh
             && appSummaryResponse?.appDescriptionBrandSafetyRating?.singleRating">
          <app-progress-circle [classref]="'.brandsafety-risk-chart-2'"
                               [max]="100"
                               [value]="100" [icon]="appSummaryResponse?.appDescriptionBrandSafetyRating?.singleRating === 'L' ? '&#x2713;': null"
                               [overridecolor]="colorMapping[appSummaryResponse?.appDescriptionBrandSafetyRating?.singleRating]">
            <div class="brandsafety-risk-chart-2" style="width: 214px; height: 214px;"></div>
          </app-progress-circle>
          <div class="graph-legend progress-circle">
            <div class="desc-text color-{{appSummaryResponse?.appDescriptionBrandSafetyRating?.singleRating}}">
              {{riskRateMapping[appSummaryResponse?.appDescriptionBrandSafetyRating?.singleRating]}} Risk
            </div>
          </div>
        </div>

        <div class="d-flex flex-column justify-content-center risk-content-ratings" *ngIf="appSummaryResponse">
          <div class="d-flex align-items-center" *ngFor="let ratingKey of brandSafetyRatingKeys">
            <div class="risk-content-label">
              {{ratingKey.label}}
            </div>
            <div class="progress bg-red" *ngIf="appSummaryResponse?.appDescriptionBrandSafetyRating?.showMedHigh"
                 [style.width]="(appSummaryResponse[ratingKey.key]['M'] + appSummaryResponse[ratingKey.key]['H']) / totalCount | roundpercent: 0">
            </div>
            <div class="risk-content-percent" *ngIf="appSummaryResponse?.appDescriptionBrandSafetyRating?.showMedHigh">
              {{(appSummaryResponse[ratingKey.key]['M'] + appSummaryResponse[ratingKey.key]['H']) / totalCount | roundpercent: 0}}
            </div>
            <div *ngIf="!appSummaryResponse?.appDescriptionBrandSafetyRating?.showMedHigh"
                 class="rating-icon color-{{appSummaryResponse?.appDescriptionBrandSafetyRating?.singleRating}}">
              <a class="p-0" data-toggle="tooltip" [attr.title]="riskRateMapping[appSummaryResponse?.appDescriptionBrandSafetyRating?.singleRating]">
                <i class="fa" [ngClass]="{'fa-check-circle': appSummaryResponse?.appDescriptionBrandSafetyRating?.singleRating === 'L', 'fa-exclamation-circle': appSummaryResponse?.appDescriptionBrandSafetyRating?.singleRating !== 'L'}"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wrapper">
      <div class="graph-label">App-Ads.txt Detected</div>
      <div class="risk-cont">
        <div class="graph-cont d-flex align-items-center justify-content-center app-ads-txt-graph"
             [ngClass]="{'green' : appSummaryResponse?.hasAdsTxt?.F <= 0}"
             *ngIf="appSummaryResponse && appSummaryResponse?.hasAdsTxt">
          <app-progress-circle [classref]="'.appadstxt-chart'"
                               [max]="100" [icon]="appSummaryResponse?.hasAdsTxt?.F <= 0 ? '&#x2713;' : null"
                               [value]="appSummaryResponse?.hasAdsTxt?.F > 0 ? (appSummaryResponse?.hasAdsTxt?.F / totalCount) * 100 : 100"
                               [overridecolor]="appSummaryResponse?.hasAdsTxt?.F > 0 ? colorMapping['H'] : colorMapping['L']">
            <div class="appadstxt-chart" style="width: 214px; height: 214px;"></div>
          </app-progress-circle>



          <div class="graph-legend progress-circle">
            <!--<div class="big-number">{{(currentConfig?.dashboardViewConfig?.section3?.progressCircle1?.value |-->
            <!--roundpercent: 0}}-->
            <!--</div>-->
            <div class="big-number color-H" *ngIf="appSummaryResponse?.hasAdsTxt?.F > 0 && appSummaryResponse?.hasAdsTxt?.F < totalCount">
              {{(appSummaryResponse?.hasAdsTxt?.F / totalCount) | roundpercent: 0}}
            </div>
            <!--<div class="big-number color-H" *ngIf="appSummaryResponse?.hasAdsTxt?.F >= totalCount">-->
            <!--100%-->
            <!--</div>-->
            <!--<div class="big-number color-L" *ngIf="appSummaryResponse?.hasAdsTxt?.F <= 0">-->
            <!--0%-->
            <!--</div>-->
            <div class="desc-text" *ngIf="appSummaryResponse?.hasAdsTxt?.F > 0 && appSummaryResponse?.hasAdsTxt?.F < totalCount"
                 [ngClass]="{'color-H' : appSummaryResponse?.hasAdsTxt?.F > 0, 'color-L' : appSummaryResponse?.hasAdsTxt?.F <= 0}">
              Missing
            </div>

            <div class="desc-text" *ngIf="appSummaryResponse?.hasAdsTxt?.F === 0 || appSummaryResponse?.hasAdsTxt?.F === totalCount"
                 [ngClass]="{'color-H' : appSummaryResponse?.hasAdsTxt?.F > 0, 'color-L' : appSummaryResponse?.hasAdsTxt?.F <= 0}">
              {{appSummaryResponse?.hasAdsTxt?.F > 0 ? 'High' : 'Low'}} Risk
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="wrappers-cont brand-safety-risk" *ngIf="currentConfig?.key === 'domains'">
    <div class="wrapper">
      <div class="graph-label">Brand Safety Risk</div>
      <div class="risk-cont">
        <div class="graph-cont d-flex align-items-center justify-content-center"
             *ngIf="appSummaryResponse && appSummaryResponse?.brandSafetyRisk?.showMedHigh">
          <app-progress-circle [classref]="'.brandsafety-risk-chart'"
                               [max]="100"
                               [value]="((appSummaryResponse?.brandSafetyRisk['M'] + appSummaryResponse?.brandSafetyRisk['H']) / totalCount) * 100">
            <div class="brandsafety-risk-chart" style="width: 214px; height: 214px;"></div>
          </app-progress-circle>
          <div class="graph-legend progress-circle">
            <!--<div class="big-number">{{(currentConfig?.dashboardViewConfig?.section3?.progressCircle1?.value |-->
            <!--roundpercent: 0}}-->
            <!--</div>-->
            <div class="big-number color-H">
              {{(appSummaryResponse?.brandSafetyRisk['M'] + appSummaryResponse?.brandSafetyRisk['H']) / totalCount | roundpercent: 0}}
            </div>
            <div class="desc-text color-H">Med & High Risk
            </div>
          </div>
        </div>

        <div class="graph-cont {{riskRateMapping[appSummaryResponse?.brandSafetyRisk?.singleRating]}}"
             *ngIf="appSummaryResponse && !appSummaryResponse?.brandSafetyRisk?.showMedHigh && appSummaryResponse?.brandSafetyRisk?.singleRating">
          <app-progress-circle [classref]="'.brandsafety-risk-chart-2'"
                               [max]="100"
                               [value]="100" [icon]="appSummaryResponse?.brandSafetyRisk?.singleRating === 'L' ? '&#x2713;': null"
                               [overridecolor]="colorMapping[appSummaryResponse?.brandSafetyRisk?.singleRating]">
            <div class="brandsafety-risk-chart-2" style="width: 214px; height: 214px;"></div>
          </app-progress-circle>
          <div class="graph-legend progress-circle">
            <div class="desc-text color-{{appSummaryResponse?.brandSafetyRisk?.singleRating}}">
              {{riskRateMapping[appSummaryResponse?.brandSafetyRisk?.singleRating]}} Risk
            </div>
          </div>
        </div>

        <div class="d-flex flex-column justify-content-center risk-content-ratings" *ngIf="appSummaryResponse">
          <div class="d-flex align-items-center" *ngFor="let ratingKey of brandSafetyRatingKeys">
            <div class="risk-content-label">
              {{ratingKey.label}}
            </div>
            <div class="progress bg-red" *ngIf="appSummaryResponse?.brandSafetyRisk?.showMedHigh"
                 [style.width]="(appSummaryResponse[ratingKey.key]['M'] + appSummaryResponse[ratingKey.key]['H']) / totalCount | roundpercent: 0">
            </div>
            <div class="risk-content-percent" *ngIf="appSummaryResponse?.brandSafetyRisk?.showMedHigh">
              {{(appSummaryResponse[ratingKey.key]['M'] + appSummaryResponse[ratingKey.key]['H']) / totalCount | roundpercent: 0}}
            </div>
            <div *ngIf="!appSummaryResponse?.brandSafetyRisk?.showMedHigh"
                 class="rating-icon color-{{appSummaryResponse?.brandSafetyRisk?.singleRating}}">
              <a class="p-0" data-toggle="tooltip" [attr.title]="riskRateMapping[appSummaryResponse?.brandSafetyRisk?.singleRating]">
                <i class="fa" [ngClass]="{'fa-check-circle': appSummaryResponse?.brandSafetyRisk?.singleRating === 'L', 'fa-exclamation-circle': appSummaryResponse?.brandSafetyRisk?.singleRating !== 'L'}"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wrapper">
      <div class="graph-label">Ads.txt</div>
      <div class="risk-cont">
        <div class="graph-cont d-flex align-items-center justify-content-center app-ads-txt-graph"
             [ngClass]="{'green' : appSummaryResponse?.isAdsDotTxtExist?.F <= 0}"
             *ngIf="appSummaryResponse && appSummaryResponse?.isAdsDotTxtExist">
          <app-progress-circle [classref]="'.appadstxt-chart'"
                               [max]="100" [icon]="appSummaryResponse?.isAdsDotTxtExist?.F <= 0 ? '&#x2713;' : null"
                               [value]="appSummaryResponse?.isAdsDotTxtExist?.F > 0 ? (appSummaryResponse?.isAdsDotTxtExist?.F / totalCount) * 100 : 100"
                               [overridecolor]="appSummaryResponse?.isAdsDotTxtExist?.F > 0 ? colorMapping['H'] : colorMapping['L']">
            <div class="appadstxt-chart" style="width: 214px; height: 214px;"></div>
          </app-progress-circle>
          <div class="graph-legend progress-circle">
            <div class="big-number color-H" *ngIf="appSummaryResponse?.isAdsDotTxtExist?.F > 0 && appSummaryResponse?.isAdsDotTxtExist?.F < totalCount">
              {{(appSummaryResponse?.isAdsDotTxtExist?.F / totalCount) | roundpercent: 0}}
            </div>
            <div class="desc-text" *ngIf="appSummaryResponse?.isAdsDotTxtExist?.F > 0 && appSummaryResponse?.isAdsDotTxtExist?.F < totalCount"
                 [ngClass]="{'color-H' : appSummaryResponse?.isAdsDotTxtExist?.F > 0, 'color-L' : appSummaryResponse?.isAdsDotTxtExist?.F <= 0}">
              Missing
            </div>

            <div class="desc-text" *ngIf="appSummaryResponse?.isAdsDotTxtExist?.F === 0 || appSummaryResponse?.isAdsDotTxtExist?.F === totalCount"
                 [ngClass]="{'color-H' : appSummaryResponse?.isAdsDotTxtExist?.F > 0, 'color-L' : appSummaryResponse?.isAdsDotTxtExist?.F <= 0}">
              {{appSummaryResponse?.isAdsDotTxtExist?.F === 0 ? 'Low' : 'High'}} Risk
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- IVT% and Viewability% -->
  <div class="wrappers-cont">
    <div class="wrapper section5">
      <div class="graph-label">IVT</div>
      <div class="graph-cont" [ngClass]="{'Low' : appSummaryResponse?.givtSivtRate?.average * 100 <= 0}">
        <app-progress-circle [classref]="'.ivt-risk-chart'"
                             [max]="100" [icon]="appSummaryResponse?.givtSivtRate?.average * 100 <= 0 ? '&#x2713;' : null"
                             [value]="appSummaryResponse?.givtSivtRate?.average > 0 ? appSummaryResponse?.givtSivtRate?.average * 100 : 100"
                             [overridecolor]="appSummaryResponse?.givtSivtRate?.average * 100 > 0 ? '#FA574B': '#3CC778'">
          <div class="ivt-risk-chart" style="width: 214px; height: 214px;"></div>
        </app-progress-circle>


        <div class="graph-legend progress-circle">
          <!--<div class="big-number">{{(currentConfig?.dashboardViewConfig?.section3?.progressCircle1?.value |-->
          <!--roundpercent: 0}}-->
          <!--</div>-->
          <div class="big-number" *ngIf="appSummaryResponse?.givtSivtRate?.average * 100 > 0 && appSummaryResponse?.givtSivtRate?.average * 100 < 100"
               [ngClass]="{'color-H': appSummaryResponse?.givtSivtRate?.average * 100 > 0, 'color-L': appSummaryResponse?.givtSivtRate?.average * 100 <= 0}">
            {{appSummaryResponse?.givtSivtRate?.average | roundpercent: 0}}
          </div>
          <div class="desc-text" *ngIf="appSummaryResponse?.givtSivtRate?.average * 100 > 0 && appSummaryResponse?.givtSivtRate?.average * 100 < 100"
               [ngClass]="{'color-H': appSummaryResponse?.givtSivtRate?.average * 100 > 0, 'color-L': appSummaryResponse?.givtSivtRate?.average * 100 <= 0}">
            Average
          </div>
          <div class="desc-text" *ngIf="appSummaryResponse?.givtSivtRate?.average * 100 === 0 || appSummaryResponse?.givtSivtRate?.average * 100 === 100"
               [ngClass]="{'color-H': appSummaryResponse?.givtSivtRate?.average * 100 > 0, 'color-L': appSummaryResponse?.givtSivtRate?.average * 100 <= 0}">
            {{appSummaryResponse?.givtSivtRate?.average * 100 === 0 ? 'Low': 'High'}} Risk
          </div>
        </div>
      </div>
      <div class="summary-cont">
        <div class="big-number" *ngIf="appSummaryResponse?.givtSivtRate?.appsLess5percent > 0 && appSummaryResponse?.givtSivtRate?.appsLess5percent < totalCount">
          {{appSummaryResponse?.givtSivtRate?.appsLess5percent / totalCount | roundpercent: 0}}
        </div>
        <div class="big-number color-H" *ngIf="appSummaryResponse?.givtSivtRate?.appsLess5percent <= 0">
          0%
        </div>
        <div class="big-number color-L" *ngIf="appSummaryResponse?.givtSivtRate?.appsLess5percent === totalCount">
          100%
        </div>
        <div class="desc-text">{{currentConfig?.key === 'apps' || currentConfig?.key === 'ctv' ? 'Apps' : 'Domains'}} Less than 5% IVT</div>
        <ng-container *ngIf="currentConfig?.key !== 'ctv'">
          <div class="percentage-bars">
            <div class="d-flex">
              <div class="label">SIVT</div>
              <div class="percentage-bar">
                <div style="background: #2652B2; border-radius: 10px; height: 16px;" [style.width]="appSummaryResponse?.sivtRate | roundpercent: 0"></div>
                <div class="label">{{appSummaryResponse?.sivtRate | roundpercent: 0}}</div>
              </div>
            </div>
            <div class="d-flex">
              <div class="label">GIVT</div>
              <div class="percentage-bar">
                <div style="width: 26%; background: #61A5ED; border-radius: 10px; height: 16px;" [style.width]="appSummaryResponse?.givtRate | roundpercent: 0"></div>
                <div class="label">{{appSummaryResponse?.givtRate | roundpercent: 0}}</div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="wrapper section5">
      <div class="graph-label">{{viewabilityLabel ? viewabilityLabel : 'Viewability'}}</div>
      <div class="graph-cont viewability-graph">
        <app-progress-circle [classref]="'.view-risk-chart'" [reverse]="true"
                             [max]="100" [icon]="'&#x2713;'"
                             [value]="appSummaryResponse?.nonGivtSivtViewability > 0 ? appSummaryResponse?.nonGivtSivtViewability * 100: 100"
                             [overridecolor]="'#3CC778'">
          <div class="view-risk-chart" style="width: 214px; height: 214px;"></div>
        </app-progress-circle>
        <div class="graph-legend progress-circle">
          <!--<div class="big-number">{{(currentConfig?.dashboardViewConfig?.section3?.progressCircle1?.value |-->
          <!--roundpercent: 0}}-->
          <!--</div>-->
          <div class="big-number color-L" *ngIf="appSummaryResponse?.nonGivtSivtViewability * 100 > 0 && appSummaryResponse?.nonGivtSivtViewability * 100 < 100">
            {{appSummaryResponse?.nonGivtSivtViewability | roundpercent: 0}}
          </div>
          <div class="desc-text color-L" *ngIf="appSummaryResponse?.nonGivtSivtViewability * 100 > 0 && appSummaryResponse?.nonGivtSivtViewability * 100 < 100">
            Average
          </div>

          <div class="desc-text color-L" *ngIf="!(appSummaryResponse?.nonGivtSivtViewability * 100 > 0 && appSummaryResponse?.nonGivtSivtViewability * 100 < 100)">
            Low Risk
          </div>
        </div>
      </div>
      <div class="summary-cont" *ngIf="appSummaryResponse?.topAdSizes?.length > 0">
        <div class="label">Top Ad Sizes</div>
        <div class="percentage-bars">
          <div class="d-flex" *ngFor="let adSize of appSummaryResponse?.topAdSizes">
            <div class="label">{{adSize.size}}</div>
            <div class="percentage-bar">
              <div style="background: #2652B2; border-radius: 10px; height: 16px;" [style.width]="(adSize?.count / totalCount)| roundpercent: 0"></div>
              <div class="label">{{(adSize?.count / totalCount)| roundpercent: 0}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
